// extracted by mini-css-extract-plugin
module.exports = {"content":"termCondition_content_3aNAi","title":"termCondition_title_3wg2O","fs":"termCondition_fs_25Ia7"};